var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 37,
    height: 37,
    rx: 7,
    fill: "#05F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 9,
    stroke: "#05F",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0599 27.5729H25.6161V25.4604H18.0599V27.5729ZM18.0599 23.2125H28.8932V21.1H18.0599V23.2125ZM18.0599 18.8521H28.8932V16.7396H18.0599V18.8521ZM15.8391 31.9062C15.2613 31.9062 14.7648 31.6986 14.3495 31.2833C13.9342 30.8681 13.7266 30.3715 13.7266 29.7937V14.5187C13.7266 13.941 13.9342 13.4444 14.3495 13.0292C14.7648 12.6139 15.2613 12.4062 15.8391 12.4062H31.1141C31.6918 12.4062 32.1884 12.6139 32.6036 13.0292C33.0189 13.4444 33.2266 13.941 33.2266 14.5187V29.7937C33.2266 30.3715 33.0189 30.8681 32.6036 31.2833C32.1884 31.6986 31.6918 31.9062 31.1141 31.9062H15.8391ZM15.8391 29.7937H31.1141V14.5187H15.8391V29.7937ZM15.8391 14.5187V29.7937V14.5187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceIcon);
export default __webpack_public_path__ + "static/media/sourceIcon.4e52741508a3e0f2073023b6a4e5cb70.svg";
export { ForwardRef as ReactComponent };